<template>
  <div class="product-item-order">
    <!-- 主商品信息 -->
    <div class="product-info" @click="handleClick()">
      <div class="product-img">
        <img v-lazy="productImg" alt="" />
      </div>
      <div class="product-des">
        <div class="name_number">
          <div class="name lc-2">
            <img
              class="act-tag"
              v-if="commodity.actTagCode"
              :src="require(`@/assets/img/order/${commodity.actTagCode}.png`)"
              alt=""
            />
            <span>{{ productName[0] }}</span>
          </div>
          <div class="number">X{{ commodity.quantity }}</div>
        </div>
        <div class="version" v-if="productName[1]">
          <div v-for="(v, i) in productName[1].split(' | ')" :key="i">
            <span class="line" v-if="i > 0"></span>
            <span>{{ v.trim() }}</span>
          </div>
        </div>
        <div class="price">
          <div class="symbol">￥</div>
          <div class="int">{{ String(salePrice).split('.')[0] }}</div>
          <div class="point">.{{ String(salePrice.toFixed(2)).split('.')[1] }}</div>
        </div>
        <!-- 待评价tab，存在评价有礼活动（常规、限时活动）且有提示文案的时候，替换官方保障 -->
        <p
          v-if="tabId == 3 && productInfo.commentDesc"
          class="comment-tips"
          v-html="highLightTip(productInfo.commentDesc)"
        ></p>
        <p
          class="ensure lc-3"
          v-else-if="commodity.actTagCode != 'additionalBuy' && commodityServiceTips && commodityServiceTips.length > 0"
        >
          <template v-for="(v, i) in commodityServiceTips">
            <span class="dot" v-if="i != 0" :key="i">·</span>
            <span :class="i == 0 ? 'ensure-icon' : ''" :key="v.serviceName">{{ v.serviceName }}</span>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import app from 'utils/app'
import env from 'utils/clientEnv'
export default {
  name: 'ProductItem',
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    orderNo: String,
    orderBase: Object,
    grouponType: Number,
    grouponStatus: {
      type: Number,
      default: 0
    },
    tempTerminal: {
      type: Number || null
    },
    // 是否跳转到详情页
    linkToProduct: {
      type: Boolean,
      default: true
    },
    tabId: Number
  },
  data() {
    return {}
  },
  computed: {
    commodity() {
      let commodity = this.productInfo.orderCommodity || this.productInfo.orderCommodityVO
      if (this.orderBase.purchaseChannel == 1 && !commodity.actTagCode) {
        commodity.actTagCode = 'live'
      }
      return commodity
    },
    commodityServiceTips() {
      return this.productInfo?.commodityServiceTips || []
    },
    // 商品名称 分成两行，一行
    productName() {
      const strArr = this.commodity.commodityName.split(/(\s+\d*G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*.)/)
      const str1 = strArr[0].trim()
      let arr2 = strArr.slice(1)
      // 判断sku版本之后紧跟着一个（,而且规格_颜色字符串内存在中文括号时，增加新的名称规则逻辑。
      if (arr2[0] && arr2[0].indexOf('（') === arr2[0].length - 1) {
        if (arr2.join('').split(/(（.*）)/).length > 1) {
          arr2 = this.commodity.commodityName.split(/(\s+\d*G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]（.*）)/).slice(1)
        }
      }
      const str2 = arr2
        .filter(v => v.trim())
        .map(v => v.trim())
        .join(' | ')
      return [str1, str2]
    },
    salePrice() {
      return this.productInfo.commodityFinalAmount
    },
    productImg() {
      return this.productInfo.orderCommoditySuite?.suitePic || this.commodity.commodityImgUrl
    },
    isVivoPlus() {
      let deliveryMode = this.orderBase.offlineOrderInfo?.deliveryMode
      return deliveryMode === 2 || deliveryMode === 3
    }
  },
  methods: {
    highLightTip(tip = '') {
      return tip.replace(/{/gi, '<i class="integral">').replace(/}/gi, '</i>')
    },
    handleClick() {
      const { type, orderNo, orderBase, linkBase, linkBasePlus } = this
      if (type === 'list') {
        // 用 push 会存在vuex的数据无法刷新，暂时使用 href
        let url = `/my/order/detail?orderNo=${orderNo}&tempTerminal=${this.tempTerminal}`
        if (orderBase.businessOrderNo) {
          url += `&vivoPlusNo=${orderBase.businessOrderNo}`
        }
        this.$router.push(url)
      } else if (type === 'detail') {
        if ((this.orderType == '12' || this.orderBase?.orderType == '12') && !env.isvChat) {
          this.$toast('内购商品不可查看')
          return
        }
        let link = ''
        if (this.isVivoPlus) {
          // 兜底场景，置换vivo+商品信息失败时触发 || ios官网app内打开的链接不支持
          if (!this.commodity.vivoPlusSpuId || env.isIOSVivoApp) {
            this.$toast('该商品不可查看，如需购买请联系导购')
            return
          }
          link = `${linkBasePlus}/product?spuId=${this.commodity.vivoPlusSpuId}&skuId=${this.commodity.vivoPlusSkuId}&virtualStoreCode=2&vpid=guanwang`
        } else if (this.grouponStatus !== 0) {
          let types = this.grouponType ? 'lottery' : 'group'
          link = `${linkBase}/product/${this.commodity.commoditySpuId}?skuId=${this.commodity.commoditySkuId}&channel=${types}`
        } else if (this.linkToProduct) {
          link = `${linkBase}/product/${this.commodity.commoditySpuId}?skuId=${this.commodity.commoditySkuId}`
        }
        app.openNewWebview({
          url: link
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
